import type { ReactNode } from "react";

export interface PageHeaderProps {
  icon?: ReactNode;
  title: string;
  subtitle?: string;
  actions?: ReactNode;
  children?: ReactNode;
}

export function PageHeader({ icon, title, subtitle, actions, children }: Readonly<PageHeaderProps>) {
  return (
    <div>
      <div className="flex items-start justify-between gap-3">
        <div className="flex min-w-0 items-center gap-3">
          {icon && <span className="shrink-0">{icon}</span>}
          <div className="min-w-0">
            <h1 className="text-content-primary [font:var(--type-h2)]">{title}</h1>
            {subtitle && <p className="mt-1 text-sm text-content-tertiary">{subtitle}</p>}
          </div>
        </div>
        {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
      </div>
      {children}
    </div>
  );
}
